module.exports = "/assets/packs/images/b74fe99863fb5f315593b2dea9d18e1f.png";